import { http } from '@/providers/apis/http';

export class MediaAPI {

    private static INSTANCE = new MediaAPI();

    private namespace = 'api/nucleus-media/v1';

    static get instance() {
        return this.INSTANCE;
    }

    public uploadFile(fileData: FormData, type: any, isAudio = false) {
        const headers = http.getTokenHeaders();
        const formData: any = new FormData();
        formData.append('entity_type', 'content');
        formData.append('file', fileData);
        const endpoint = `${this.namespace}/uploads`;
        headers['Content-Type'] = 'multipart/form-data';
        return http.postFile(endpoint, headers, formData).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
}

export const mediaAPI = MediaAPI.instance;
